import * as angular from 'angular';
import * as _ from 'lodash';

import { TagDateValue, WidgetValuesReadConfiguration, AggregationMode, ReadType, IBindable, RowSpacing } from '../../models';
import { IDateRangeService, IwidgetIntervalHelperService } from '../../services';
import { Helper } from '../../common';
import { IdataWidget, WidgetWithErrors, ISeriesConfiguration } from '../../widgets';
import { TableWidgetConfiguration } from './table.configuration';
import { TableWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class TableWidget extends WidgetWithErrors implements IdataWidget {
    baseType = definition.baseType;
    col = 0;
    configuration: TableWidgetConfiguration;
    data: TagDateValue[];
    exportFormats = ['csv'];
    exportToCsv: () => void;
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    name = definition.title;
    row = 0;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor(
        private _$q: angular.IQService,
        private _dateRangeService: IDateRangeService,
        private __intervalHelper: IwidgetIntervalHelperService
    ) {
        super(__intervalHelper);
        this.guid = Helper.getGuid();
        this.configuration = new TableWidgetConfiguration();
        if (this.configuration.rowSpacing === undefined) {
            this.configuration.rowSpacing = RowSpacing.Normal;
        }
    }

    interval() {
        const result = this.__intervalHelper.getInterval(this._dateRangeService.beginDate() as string, this._dateRangeService
            .endDate() as string, this.configuration);
        return result;
    }

    getSeriesGuids(): string[] {
        return this.configuration.rows.map(d => d.guid);
    }

    getReadConfiguration(beginDate: string, endDate: string): WidgetValuesReadConfiguration {
        const readTypes = [this.configuration.aggregation.mode === AggregationMode.None ? ReadType.AllValues : ReadType.AggregatedValueList];
        if (this.configuration.hasTrend && readTypes.indexOf(ReadType.AllValues) < 0) {
            readTypes.push(ReadType.AllValues);
        }
        return this.getReadConfigurationBaseList(
            beginDate,
            endDate,
            this.configuration.rows,
            this.configuration,
            this.configuration.aggregation,
            this.configuration.isQualityVisible,
            false, false, false, false,
            readTypes,
            _.some(this.configuration.rows, r => r.isAlarmVisible),
            this.configuration.options?.variableTypeGuid,
            this.configuration.options?.unitGuid
        );
    }

    getSeriesListAsync(): angular.IPromise<IBindable[]> {
        //TODO relative path
        const result = this.configuration.rows.map(d => {
            return {
                guid: d.guid,
                originalGuid: d.guid,
                value: d.value,
                relativePath: '', //d.relativePath,
                isBoundToGroup: d.isBoundToGroup,
                isBoundIncludehildren: d.isBoundIncludehildren
            };
        });
        return this._$q.when(result);
    }

    getReadConfigurationAsync(): angular.IPromise<WidgetValuesReadConfiguration> {
        return this.getSeriesListAsync()
            .then(data => {
                const hasQuality = this.configuration.isQualityVisible;
                const hasMissingRanges = false;
                const hasContext = false;
                const hasTendency = false;
                const hasTarget = false;
                const aggregation = this.configuration.aggregation;
                return this.createConfiguration(
                    data,
                    aggregation,
                    hasQuality,
                    hasMissingRanges,
                    hasContext,
                    hasTendency,
                    hasTarget,
                    undefined,
                    this.configuration.options?.variableTypeGuid,
                    this.configuration.options?.unitGuid
                );
            });
    }

    getSeries(): ISeriesConfiguration[] {
        return (this.configuration as any).rows;
    }

    setSeries(series: ISeriesConfiguration[]) {
        (this.configuration as any).rows = series;
    }
}